<template>
  <div class="calc">
    <div class="calc__caption mb-4">
      <div class="calc__caption-icon mr-2">
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <rect width="43" height="43" fill="url(#pattern0)" />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlink:href="#image0_4825_154927"
                transform="scale(0.00806452)"
              />
            </pattern>
            <image
              id="image0_4825_154927"
              width="124"
              height="124"
              xlink:href="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </div>
      <div>
        Калькулятор дозирования для СИНАГИС<sup style="color: #1f1f1f">®</sup>
      </div>
    </div>
    <div class="calc__description mb-6">
      Введите вес пациента и нажмите «Рассчитать дозу» , чтобы получить дозу в
      мл.
    </div>
    <div class="calc__block">
      <div class="calc__form-block">
        <div class="calc__form">
          <div class="calc__form-title">Вес пациента:</div>
          <div class="calc__input-wrap mr-2">
            <input
              type="number"
              v-model="kg"
              class="calc__input"
              :class="{ 'calc__input-error': error }"
            />
            <label class="calc__label">кг</label>
          </div>
          <div class="calc__input-wrap">
            <input
              type="number"
              v-model="g"
              class="calc__input"
              :class="{ 'calc__input-error': error }"
            />
            <label class="calc__label">г</label>
          </div>
        </div>
        <div class="calc__warning" :class="{ 'calc__warning-error': error }">
          <svg
            class="mr-2"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10.7031"
              cy="10.5"
              r="8.26163"
              stroke="currentColor"
              stroke-width="0.976744"
            />
            <path
              d="M9.91223 12.1551H11.0902V13.2539H9.91223V12.1551ZM9.95618 6.97735H11.055V8.78823L10.7649 11.5046H10.2463L9.95618 8.78823V6.97735Z"
              fill="currentColor"
            />
          </svg>
          не больше 15,8 кг
        </div>
        <div
          class="button calc__button"
          :class="{ button_disabled: !kg }"
          :disabled="!kg"
          @click="calculate"
        >
          Рассчитать дозу
        </div>
      </div>
      <div class="calc__result" v-if="dose">
        <div class="calc__result-caption">
          Доза СИНАГИС<sup style="color: #1f1f1f">®</sup>
        </div>
        <div class="calc__result-dose">{{ dose }} мл</div>
        <div class="calc__result-description">
          Рекомендуемая доза СИНАГИС<sup style="color: #1f1f1f">®</sup>
          составляет 15 мг/кг массы тела, вводимая ежемесячно путем
          внутримышечной инъекции: масса пациента (кг) x 15 мг/кг ÷ 100 мг/мл.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "calculator",
  data: () => ({
    kg: null,
    g: null,
    dose: null,
    error: false,
  }),
  methods: {
    calculate() {
      let weight = (parseInt(this.kg) * 1000 + parseInt(this.g || 0)) / 1000;
      if (weight > 15.8) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 1000);
        return;
      }
      if (weight < 1.75) {
        this.dose = "0,2";
        return;
      }
      if (weight < 2.5) {
        this.dose = "0,3";
        return;
      }
      if (weight < 3) {
        this.dose = "0,4";
        return;
      }
      if (weight < 3.75) {
        this.dose = "0,5";
        return;
      }
      if (weight < 4.5) {
        this.dose = "0,6";
        return;
      }
      if (weight < 5) {
        this.dose = "0,7";
        return;
      }
      if (weight < 5.75) {
        this.dose = "0,8";
        return;
      }
      if (weight < 6.5) {
        this.dose = "0,9";
        return;
      }
      if (weight < 7) {
        this.dose = "1,0";
        return;
      }
      if (weight < 7.75) {
        this.dose = "1,1";
        return;
      }
      if (weight < 8.5) {
        this.dose = "1,2";
        return;
      }
      if (weight < 9) {
        this.dose = "1,3";
        return;
      }
      if (weight < 9.75) {
        this.dose = "1,4";
        return;
      }
      if (weight >= 9.75) {
        this.dose = "1,5";
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calc {
  padding: 32px;
  background: #ddf0f7;
  border: 1px solid #ebefee;
  border-radius: 8px;

  &__caption {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }

  &__description {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
  }

  &__form {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &-title {
      margin-right: 16px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #1f1f1f;
    }
  }

  &__label {
    margin-left: 4px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #00548b;
  }

  &__warning {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #00548b;

    &-error {
      color: rgb(214, 3, 3);
    }
  }

  &__button {
    margin-top: 24px;
    width: 318px;
    background-color: #00548b;
    color: #fff;
    @media screen and (max-width: 767px) {
      width: 100%;
    }
    &:hover {
      background-color: #0277c5;
    }
  }

  &__input {
    width: 56px;
    height: 40px;
    background: #f8f8f8;
    border: 1px solid #d2d2d2;
    border-radius: 10px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #3c4242;

    &-error {
      color: rgb(214, 3, 3);
      border-color: rgb(214, 3, 3);
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &-wrap {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }

  &__form-block {
    @media screen and (max-width: 1199px) {
      width: 100%;
    }
  }

  &__block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    @media screen and (max-width: 1199px) {
      flex-direction: column;
    }
  }

  &__result {
    margin-left: auto;
    padding: 24px;
    background: #ffffff;
    border-radius: 8px;
    width: 353px;
    height: 208px;
    @media screen and (max-width: 1199px) {
      margin-top: 22px;
      margin-left: 0;
      width: 100%;
      height: auto;
    }

    &-caption {
      margin-bottom: 8px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #1f1f1f;
    }

    &-dose {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 28px;
      line-height: 32px;
      color: #ff547c;
      margin-bottom: 16px;
    }

    &-description {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
    }
  }
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
